import React, {useEffect, useRef} from 'react';
import {
  registerReactComponent
} from '@trp-beacon-ui-kit/foundation/react/register';
import {
  BeaconDatePicker
} from '@trp-beacon-ui-kit/foundation/components/beacon-date-picker';
// This is the name of your project, library, application, etc. - make sure to use a specific prefix
const projectNamePrefix = 'rmd';

//This is your React component that can be used in the return/render block below
const RMDBeaconDatePicker = registerReactComponent(
  projectNamePrefix,
  BeaconDatePicker
);

const DatePickerBeacon = ({
  label = 'Birthdate',
  name = 'birthdate',
  hint = '',
  errorMessage = 'Enter a valid date of birth',
  requiredMessage = 'Required Field',
  iconPosition = 'left',
  min = '1907-01-01',
  max = '2005-12-31',
  invalid = false,
  disabled = false,
  required = false,
  errorsMap = {
    min: 'Value must be 01-01-1907 or later',
    max: 'Value must be 12-31-2005 or earlier',
  },
  id,
  handleBlur,
  handleChange,
  value,
}) => {
  const rmdDatePicker = useRef();
  useEffect(() => {
    const temp = rmdDatePicker;
    if (handleChange) {
      temp.current.addEventListener('beacon-event-input', handleChange);
    }
    if (handleBlur) {
      temp.current.addEventListener('beacon-event-blur', handleBlur);
    }
    return () => {
      if (handleBlur) {
        temp.current.removeEventListener('beacon-event-blur', handleBlur);
      }
      if (handleChange) {
        temp.current.removeEventListener('beacon-event-input', handleChange);
      }
    };
  }, [handleChange, handleBlur]);
  return (
    <div class="app-component">
      <RMDBeaconDatePicker
        ref={rmdDatePicker}
        id={id}
        label={label}
        value={value}
        name={name}
        hint={hint}
        error-message={errorMessage}
        required-message={requiredMessage}
        icon-position={iconPosition}
        min={min}
        max={max}
        invalid={invalid}
        disabled={disabled}
        required={required}
        errorsMap={errorsMap}
      />
    </div>
  );
};

export default DatePickerBeacon;
